import { motion } from "framer-motion";

// Brand Logos
import CityCraft from "../../Assets/Brand/Citycraft.jpeg";
import Cuisine from "../../Assets/Brand/Cuisine.jpeg";
import Gupta from "../../Assets/Brand/Gupta.jpeg";
import Inframyte from "../../Assets/Brand/Inframyte.jpeg";
import Kitchen from "../../Assets/Brand/kitchen.jpeg";
import Makau from "../../Assets/Brand/MAkau.jpeg";
import Mounts from "../../Assets/Brand/Mounts.jpeg";
import Urban from "../../Assets/Brand/urban.jpeg";
import Zythum from "../../Assets/Brand/zythum.jpeg";

const clients = [
  { name: "Urban Company", location: "India", logo: Urban },
  { name: "City Craft", location: "India", logo: CityCraft },
  { name: "Ishtaa ", location: "India", logo: Cuisine },
  { name: "Gupta Enterprises", location: "India", logo: Gupta },
  { name: "Inframyte Construction", location: "India", logo: Inframyte },
  { name: "Telugu Kitchen And Bar", location: "India", logo: Kitchen },
  { name: "Makau Designs", location: "India", logo: Makau },
  { name: "7Mounts Pioneering Innovation", location: "India", logo: Mounts },
  { name: "Zythum Brewing co.", location: "India", logo: Zythum },
];

// duplicate for seamless loop
const loopClients = [...clients, ...clients];

export default function Clients() {
  return (
    <section className="py-28 bg-[#F5F7FB] dark:bg-[#050816] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2 className="text-4xl font-extrabold mb-4">
            Trusted by{" "}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              Growing Brands
            </span>
          </h2>
          <p className="text-slate-600 dark:text-slate-400">
            Businesses across industries trust 360Support for reliable and scalable digital solutions.
          </p>
        </div>

        {/* Stats */}
        <div className="flex justify-center gap-12 mb-16">
          {[
            { label: "Brands Served", value: "25+" },
            { label: "Projects Delivered", value: "60+" },
            { label: "Client Satisfaction", value: "98%" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-4xl font-extrabold text-blue-600">
                {stat.value}
              </p>
              <p className="text-sm text-slate-600 dark:text-slate-400">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* Auto Sliding Logos */}
        <motion.div
          className="flex gap-8"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            duration: 25,
            ease: "linear",
            repeat: Infinity,
          }}
        >
          {loopClients.map((client, index) => (
            <div
              key={index}
              className="
                min-w-[220px]
                rounded-2xl p-6
                bg-white/70 dark:bg-white/5
                backdrop-blur-xl
                border border-black/5 dark:border-white/10
                shadow-sm hover:shadow-xl
                transition-all
              "
            >
              <div className="flex flex-col items-center gap-4">
                <img
                  src={client.logo}
                  alt={client.name}
                  className="
                    max-h-14 object-contain
                    grayscale hover:grayscale-0
                    transition duration-300
                  "
                />
                <div className="text-center">
                  <p className="text-sm font-semibold">{client.name}</p>
                  <p className="text-xs text-slate-500">{client.location}</p>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
